module.exports = __webpack_public_path__ + "img/logo-light.4c24a925.png";